import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import VigorbuySpreadsheetGuide from "../pages/article/vigorbuy-spreadsheet-guide/page";
import BestHoodiesSweaters from "../pages/article/best-hoodies-sweaters-vigorbuy-spreadsheet/page";
import BestTshirtsStreetwear from "../pages/article/best-tshirts-streetwear-vigorbuy-spreadsheet/page";
import UltimateJackets from "../pages/article/ultimate-jackets-outerwear-guide/page";
import BestBudgetFinds from "../pages/article/best-budget-finds-under-30/page";
import TopAccessoriesBags from "../pages/article/top-accessories-bags-vigorbuy/page";
import VsDirectShopping from "../pages/article/vigorbuy-spreadsheet-vs-direct-shopping/page";
import SpotQuality from "../pages/article/how-to-spot-quality-products/page";
import ShippingGuide from "../pages/article/shipping-delivery-guide-vigorbuy/page";
import SafetyBuyerProtection from "../pages/article/safety-buyer-protection-vigorbuy/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/guide/vigorbuy-spreadsheet-guide",
    element: <VigorbuySpreadsheetGuide />,
  },
  {
    path: "/guide/best-hoodies-sweaters-vigorbuy-spreadsheet",
    element: <BestHoodiesSweaters />,
  },
  {
    path: "/guide/best-tshirts-streetwear-vigorbuy-spreadsheet",
    element: <BestTshirtsStreetwear />,
  },
  {
    path: "/guide/ultimate-jackets-outerwear-guide",
    element: <UltimateJackets />,
  },
  {
    path: "/guide/best-budget-finds-under-30",
    element: <BestBudgetFinds />,
  },
  {
    path: "/guide/top-accessories-bags-vigorbuy",
    element: <TopAccessoriesBags />,
  },
  {
    path: "/guide/vigorbuy-spreadsheet-vs-direct-shopping",
    element: <VsDirectShopping />,
  },
  {
    path: "/guide/how-to-spot-quality-products",
    element: <SpotQuality />,
  },
  {
    path: "/guide/shipping-delivery-guide-vigorbuy",
    element: <ShippingGuide />,
  },
  {
    path: "/guide/safety-buyer-protection-vigorbuy",
    element: <SafetyBuyerProtection />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;